import script from "./PlanosEditarView.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanosEditarView.vue?vue&type=script&setup=true&lang=js"

import "./PlanosEditarView.vue?vue&type=style&index=0&id=64823b1c&lang=css"

const __exports__ = script;

export default __exports__